import type { LlmModelOption } from "@/types";

/** Registry transports the 1차 scan can run on, and how it scans on each (the server decides by transport). */
export const SCAN_METHODS: Record<string, string> = {
  gemini: "여러 메시지 묶음",
  claude_cli: "CLI 묶음·Qwen 예비",
  qwen: "여러 메시지 묶음",
  enaible: "1건씩·생각 짧게",
  openrouter: "1건씩·생각 짧게",
};

/** The endpoint key a per-message 1차 transport needs on the SAMS server. */
export const SCAN_KEYS: Record<string, string> = {
  enaible: "게이트웨이 키 LLM_GATEWAY_API_KEY",
  openrouter: "OpenRouter 키 OPENROUTER_API_KEY",
};

/** Enabled registry models the 1차 scan can use. */
export const scanModels = (models: LlmModelOption[]) =>
  models.filter((m) => m.is_enabled && Object.prototype.hasOwnProperty.call(SCAN_METHODS, m.transport));

/** A 1차 model picker label: the model and how the scan runs on it. */
export const modelLabel = (model: LlmModelOption) =>
  SCAN_METHODS[model.transport] ? `${model.label} · ${SCAN_METHODS[model.transport]}` : model.label;

/** The 1.1차 client accepts Gemini or the two routed transports, not legacy per-message HTTP. */
export const reviewModels = (models: LlmModelOption[]) =>
  models.filter((m) => m.is_enabled && ["gemini", "claude_cli", "qwen"].includes(m.transport));

/** Built-in server defaults; an active 1차 prompt or server settings can override them. */
export const DETECTION_DEFAULT_MODEL_LABEL = "서버 기본: Claude CLI · Qwen 예비";
